/**
 * Builds the optimistic local event for a chat message in the shape that matches the
 * author: `PATIENT_MESSAGE` carries the text in `content`, while `STAFF_MESSAGE` carries
 * it in `message` and adds the `staffId`.
 */
export function buildChatMessageEvent(params) {
    const { author, chatId, seq, content, files } = params;
    if (author.type === 'STAFF') {
        return {
            chatId,
            seq,
            type: 'STAFF_MESSAGE',
            staffId: author.staffId,
            message: content,
            timestamp: Date.now(),
            files,
        };
    }
    return {
        chatId,
        seq,
        type: 'PATIENT_MESSAGE',
        content,
        timestamp: Date.now(),
        files,
    };
}
//# sourceMappingURL=buildChatMessageEvent.js.map